import { useActionsColumn } from '../../../../../features/table/helpers/useActionsColumn';
import { UserActionsBodyCell } from '../../../components/UsersTable/UserActionsBodyCell';

export function useUserActionsColumn() {
  return useActionsColumn({
    render: (text: string, row: any) => <UserActionsBodyCell row={row} />,
  });
}
